const innerVerticalMargin = 20;

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: 14,
    color: '#596168',
    textAlign: 'center',
    margin: 'auto auto',
    width: '100%',
  },

  loadingBar: {
    width: 120,
    marginBottom: innerVerticalMargin,
  },

  icon: {
    marginBottom: innerVerticalMargin,
  },

  subtitle: {
    marginBottom: innerVerticalMargin,
  },
});

export default styles;
